export const DEBUG = {
  TYPE: {
    MP: {
      PLANNING_LIST: 'planning-list',
      POS_LIST: 'points-of-sale-list',
      MISSION_PLANING_PAGE: 'mission-planning-page'
    }
  }
};